<template>
    <div class="field">
        <label v-if="label">{{ label }}</label>

        <div class="control">
            <div class="select is-fullwidth" :class="{'is-loading': loading, 'is-small': small}">
                <select
                    @input="$emit('input', $event.target.value)"
                    :value="value"
                    class="is-fullwidth"
                    :disabled="disabled">

                    <option v-if="loading">loading...</option>

                    <template v-if="Array.isArray(options)">
                        <option
                            v-for="option in options"
                            :value="option[option_value]"
                            :key="option[option_value]">

                            {{option[option_label]}}
                        </option>
                    </template>

                    <template v-else>
                        <option v-for="(option, key) in options" :value="key" :key="key">
                            {{option}}
                        </option>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Select',
    props: {
        options: [Array, Object],
        value: [Number, String],
        label: String,
        loading: { type: Boolean, default: false },
        option_label: { type: String, default: 'name' },
        option_value: { type: String, default: 'id' },
        disabled: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
</style>
